import { isValidPhoneNumber as _isValidPhoneNumber } from 'libphonenumber-js';
import { CountryCode, CountryCodes } from 'src/constants/CountryCode';

export function isValidPhoneNumber(value?: string | null, countryCode?: CountryCode | undefined): boolean {
    if (!value || value.length === 3) {
        return false;
    }
    return _isValidPhoneNumber(value, countryCode ?? CountryCodes.MX);
}
